import React from "react";
import SideNavItem from "./SideNavItem";
import {
    VersionNumber,
    NavContainer,
    NavItemsUl,
} from "../styled/Sidebar.styled";

import {utilItems} from "../utils/routes";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";
import { useVsiAppContext } from "../stores/VsiApp";
import { useEnvColor } from "../utils/hooks";

function SideNavUtilities() {
    const envColor = useEnvColor();
    const { user } = useVsiAppContext();


    return (
        <NavContainer>
            <NavItemsUl style={{ margin: '10px 0'}}>
                {utilItems.map((item, i) => (
                    item.roles.includes(user.role) ?
                        <SideNavItem {...item} key={`side-item-${item.title}-${i}`}/> : null
                ))}
            </NavItemsUl>
            <div style={{width: '100%', bottom: 0}} className={"h-100"}>
                <VersionNumber>v6.0.0.1</VersionNumber>
                <VersionNumber>{envColor}</VersionNumber>
            </div>
        </NavContainer>
    );
}
export default withErrorBoundary(SideNavUtilities, GeneralErrorBoundary);
